<div
  class="audio-player {{ hideBorder() ? '' : 'border' }}"
  [class.compact]="compact()"
>
  <!-- Audio element (hidden) -->
  <audio #audio [src]="media().src" class="hidden" preload="metadata"></audio>

  <!-- Player controls -->
  <div class="player-container">
    <!-- Play/Pause Button -->
    <button
      class="play-pause-button"
      (click)="togglePlay($event)"
      [attr.aria-label]="paused() ? 'Play' : 'Pause'"
    >
      <ion-icon [name]="paused() ? 'play' : 'pause'" class="icon"></ion-icon>
    </button>

    <!-- Progress Bar -->
    <div
      #progressBar
      class="progress-container"
      (mousedown)="startDrag($event)"
      (touchstart)="startDrag($event)"
    >
      <div class="progress-bar">
        <div class="progress-filled" [style.width.%]="progress()"></div>
      </div>
    </div>

    <!-- Time Display -->
    @if (showTime() && !compact()) {
      <div class="time-display">
        <span>{{ formatTime(currentTime()) }}</span>
        <span>/</span>
        <span>{{ formatTime(duration()) }}</span>
      </div>
    }

    <!-- Volume Control -->
    <button
      class="volume-button"
      (click)="toggleMute($event)"
      [attr.aria-label]="muted() ? 'Unmute' : 'Mute'"
    >
      <ion-icon
        [name]="muted() ? 'volume-mute' : 'volume-medium'"
        class="icon"
      ></ion-icon>
    </button>
  </div>

  <!-- Processing Indicator -->
  @if (media().processing) {
    <div class="processing-indicator">
      <p>{{ 'Audio processing...' | locale }}</p>
    </div>
  }

  @if (error()) {
    <app-validation-output [value]="error()" [type]="'error'" />
  }
</div>
